import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
  StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarPrecoPublicoDs, criarTaxasDs } from "../../DataSources";

const localStorageKey = "cadastroPrecoPublicoGridState";

export default class PrecoPublicoBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("precopublico/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Preço Público"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarPrecoPublicoDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <StateStoring
                enabled={true}
                type={"localStorage"}
                storageKey={localStorageKey}
              />
              <FilterRow visible={true} />
              <Editing allowDeleting={true} allowUpdating={true} mode />
              <Column
                dataField={"sequencial"}
                caption={"#"}
                allowEditing={false}
                width={80}
                alignment={"center"}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"descricao"} caption={"Descrição"} />
              <Column
                dataField={"precoPorUnidade"}
                caption={"Preço por Unidade"}
                format={{ type: "fixedPoint", precision: 2 }}
              />
              <Column
                dataField={"unidadeCalculo"}
                caption={"Unidade de Cálculo"}
              />
              <Column dataField={"taxaId"} caption={"Taxa"}>
                <Lookup
                  dataSource={criarTaxasDs()}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("precopublico/novo");
  }
}
